// Section 24.15 debug tab (dev builds only): the state's top-level sizes, rng state, the
// pausing and open prompts, and one key's JSON on demand.
import type { GameState, Prompt } from '../sim/api';
import { memo } from './memo';

export interface DebugVM {
  turn: number;
  rngState: number;
  eventRngState: number;
  phaseCursor: string | null;
  pendingPrompts: Prompt[];
  openPrompts: Prompt[];
  /** Top-level keys with their JSON size in characters, largest first. */
  keys: { key: string; size: number }[];
}

export const debugVM = memo((game: GameState): DebugVM => ({
  turn: game.turn,
  rngState: game.rngState,
  eventRngState: game.eventRngState,
  phaseCursor: game.phaseCursor,
  pendingPrompts: game.pendingPrompts,
  openPrompts: game.openPrompts,
  keys: Object.entries(game)
    .map(([key, value]) => ({ key, size: JSON.stringify(value).length }))
    .sort((a, b) => b.size - a.size),
}));

/** One key of the state as indented JSON (the raw state viewer). */
export function stateJson(game: GameState, key: string | null): string {
  const value = key === null ? game : (game as unknown as Record<string, unknown>)[key];
  return JSON.stringify(value, null, 2);
}
